import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { PromotionCartActionTypeEnum, PromotionExternalExposeGroup } from '../../interface';
import { PromotionCartPromotionElementDto } from '../PromotionCartPromotionElementDto';
import { AbstractPromotionCartActionDto } from './AbstractPromotionCartActionDto';
export class PromotionAddPromotionCartActionDto extends AbstractPromotionCartActionDto {
}
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiProperty({ type: () => String, example: PromotionCartActionTypeEnum.ADD_PROMOTION }),
    __metadata("design:type", String)
], PromotionAddPromotionCartActionDto.prototype, "type", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    Type(() => PromotionCartPromotionElementDto),
    ApiProperty({ type: () => PromotionCartPromotionElementDto }),
    __metadata("design:type", PromotionCartPromotionElementDto)
], PromotionAddPromotionCartActionDto.prototype, "payload", void 0);
__decorate([
    Expose({ groups: [PromotionExternalExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => String }),
    __metadata("design:type", String)
], PromotionAddPromotionCartActionDto.prototype, "message", void 0);
//# sourceMappingURL=PromotionAddPromotionCartActionDto.js.map